import { motion, AnimatePresence } from 'framer-motion';
import { observer } from "mobx-react";
import Price from "./Price";
import QuantityIndicator from "./QuantityIndicator";
import Tags from "./Tags";
import AddToCart from './AddToCart';
import ProductImage from './ProductImage';

const ProductViewDesktop = observer(({
  product,
  img,
  handleClick,
  selectedVariation,
  setSelectedVariation,
  productType,
  productDisplayType,
  setProductDisplayType,
  handleRemoveFromCart,
  handleAddToCart,
  handleClearFromCart,
  handleUpdateQuantity,
  productWeightQuantity,
  quantity,
  handleVariationChange,
  inCart,
  isImageHovered,
  setIsImageHovered,
  primaryColorRef,
}) => {
  return (
    <div className="hidden md:flex flex-col h-full">
      <header className="relative text-center">
        <div
          data-testid={`product-image-container-${product.id}`}
          className="relative w-auto pt-2 px-2"
          onMouseEnter={() => setIsImageHovered(true)}
          onMouseLeave={() => setIsImageHovered(false)}
        >
          <Tags product={product} />
          <div className="relative w-full">
            <ProductImage img={img} productName={product?.name} />
            <AnimatePresence>
              {isImageHovered && (
                <motion.div
                  data-testid={`add-to-cart-overlay-${product.id}`}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.3 }}
                  className="absolute inset-0 flex flex-col items-center justify-center z-30"
                >
                  <div
                    className={`absolute stamp-border stamp-border-sm inset-0 z-[-1] ${!primaryColorRef.current && 'bg-gray-500'}`}
                    style={{
                      backgroundImage: `radial-gradient(4px, rgba(255, 255, 255, 0) 98%, ${primaryColorRef.current}), linear-gradient(${primaryColorRef.current} 0 0)`,
                      opacity: 0.50,
                    }}
                  />
                  <div data-testid={`add-to-cart-container-${product.id}`} className="relative z-10">
                    <AddToCart
                      product={product}
                      handleRemoveFromCart={handleRemoveFromCart}
                      handleAddToCart={handleAddToCart}
                      handleUpdateQuantity={handleUpdateQuantity}
                      quantity={quantity}
                      productWeightQuantity={productWeightQuantity}
                      handleVariationChange={handleVariationChange}
                      productType={productType}
                      selectedVariation={selectedVariation}
                      setSelectedVariation={setSelectedVariation}
                      productDisplayType={productDisplayType}
                    />
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        </div>
        <div className="product-info p-3 md:p-5 cursor-pointer" onClick={handleClick}>
          <h3
            data-testid={`product-name-${product.id}`}
            className="mb-2 text-lg font-bold truncate text-heading"
            style={{ color: primaryColorRef.current }}
          >
            {product.name}
          </h3>
          <hr className="dotted-spaced my-3" />
          <Price
            product={selectedVariation || product}
            productType={productType}
            productDisplayType={productDisplayType}
            setProductDisplayType={setProductDisplayType}
          />
        </div>
      </header>
      {!!inCart && (
        <div className="absolute bottom-0 left-0 p-4">
          <QuantityIndicator inCart={inCart} handleClearFromCart={handleClearFromCart} />
        </div>
      )}
    </div>
  );
});

export default ProductViewDesktop;